import { getPlatformAdapter } from "./adapter"
import type { PlatformResult } from "./types"

export async function openExternalUrl(url: string): Promise<PlatformResult<void>> {
    return getPlatformAdapter().openExternalUrl(url)
}
